export default __webpack_public_path__ + "static/media/videoTikTok.dc87de8b.svg";